<form *ngIf="newModelForm" [formGroup]="newModelForm">
  <div class="grid">
    <div class="col-12 md:col-6">
      <div class="card p-fluid">

        <div class="d-flex mt-2 row">
          <div class="field col-6">
            <app-form-field
              formFieldId="modelFriendlyName"
              label="Model friendly name"
              [form]="newModelForm"
              controlName="modelFriendlyName">
              <input pInputText id="modelFriendlyName" type="text" formControlName="modelFriendlyName" required/>
            </app-form-field>
          </div>
          <div class="field col-6">
            <app-form-field
              formFieldId="deploymentName"
              label="Deployment name"
              [form]="newModelForm"
              controlName="deploymentName">
              <input pInputText id="deploymentName" type="text" formControlName="deploymentName" required/>
            </app-form-field>
          </div>
        </div>

        <div class="d-flex mt-2 row">
          <div class="field col-6">
            <app-form-field
              formFieldId="modelType"
              label="Model type"
              [form]="newModelForm"
              controlName="modelType">
              <input pInputText id="modelType" type="text" formControlName="modelType" required/>
            </app-form-field>
          </div>
          <div class="field col-6">
            <app-form-field
              formFieldId="endpoint"
              label="Endpoint"
              [form]="newModelForm"
              controlName="endpoint">
              <input pInputText id="endpoint" type="text" formControlName="endpoint" required/>
            </app-form-field>
          </div>
        </div>

        <div class="field grid mt-2">
          <app-form-field
            formFieldId="prompt"
            label="Prompt"
            [form]="newModelForm"
            controlName="prompt">
            <textarea pInputTextarea id="prompt" rows="8" cols="30" formControlName="prompt" required></textarea>
          </app-form-field>
        </div>

        <div class="d-flex mt-2 row">
          <div class="field col-6">
            <app-form-field
              formFieldId="maxInputTokens"
              label="Max input tokens"
              [form]="newModelForm"
              controlName="maxInputTokens">
              <input pInputText id="maxInputTokens" type="number" formControlName="maxInputTokens" required [min]="0" [step]="1"/>
            </app-form-field>
          </div>
          <div class="field col-6">
            <app-form-field
              formFieldId="maxResponseTokens"
              label="Max response tokens"
              [form]="newModelForm"
              controlName="maxResponseTokens">
              <input pInputText id="maxResponseTokens" type="number" formControlName="maxResponseTokens" required [min]="0" [step]="1"/>
            </app-form-field>
          </div>
        </div>

        <!-- Restriction Section -->
        <div class="field mt-3">
          <app-labeled-checkbox
            id="restriction"
            label="Enable restriction"
            controlName="restriction"
            [form]="newModelForm"
            cssClass="d-flex align-items-center gap-2">
          </app-labeled-checkbox>
        </div>

        <!-- Restriction Box - Roles & Note -->
        <div *ngIf="newModelForm.get('restriction')?.value" class="mt-3 p-4">
          <div class="field">
            <app-form-field
              formFieldId="rolesRestriction"
              label="Role"
              [form]="newModelForm"
              controlName="rolesRestriction"
              tooltip="Select role, which have access into this model">
              <p-multiSelect id="rolesRestriction" [options]="rolesRestrictionOptions" formControlName="rolesRestriction" placeholder="Select role" appendTo="body"></p-multiSelect>
            </app-form-field>
          </div>

          <div class="field mt-3">
            <app-form-field
              formFieldId="note"
              label="Note"
              [form]="newModelForm"
              controlName="note">
              <textarea pInputTextarea id="note" rows="3" cols="30" formControlName="note"></textarea>
            </app-form-field>
          </div>
        </div>

        <!-- Model Flags Section -->
        <div class="mt-4">
          <h5 class="mb-3 font-semibold">Model flags</h5>

          <div class="d-flex gap-4 flex-wrap">
            <div>
              <app-labeled-checkbox
                id="default"
                label="Default model"
                controlName="default"
                [form]="newModelForm"
                cssClass="d-flex align-items-center gap-2">
              </app-labeled-checkbox>
            </div>

            <div>
              <app-labeled-checkbox
                id="isSummary"
                label="Summary model"
                controlName="isSummary"
                [form]="newModelForm"
                cssClass="d-flex align-items-center gap-2">
              </app-labeled-checkbox>
            </div>

            <div>
              <app-labeled-checkbox
                id="embeddingModel"
                label="Embedding model"
                controlName="embeddingModel"
                [form]="newModelForm"
                [title]="isEmbeddingModel() ? 'If enabled embedding, current embedding model will be overridden.' : ''"
                cssClass="d-flex align-items-center gap-2">
              </app-labeled-checkbox>
            </div>
          </div>
        </div>


      </div>
    </div>
  </div>
</form>

<div class="mt-3 d-flex column-gap-3 justify-content-end">
  <button pButton pRipple type="button" class="p-button-secondary h-3rem w-full sm:w-auto" icon="pi pi-times"
          label="Cancel" (click)="onDialogCancel()"></button>
  <button pButton pRipple type="button" class="h-3rem w-full sm:w-auto" icon="pi pi-check"
          label="Confirm" (click)="onSubmit()" [loading]="processing"></button>
</div>
